import { render, staticRenderFns } from "./BorderCustoms.vue?vue&type=template&id=38838e54"
import script from "./BorderCustoms.vue?vue&type=script&lang=js"
export * from "./BorderCustoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports